export const SIDEBAR_COLLAPSED_COOKIE_NAME = 'sidebar-collapsed'
export const SIDEBAR_WIDTH_COOKIE_NAME = 'sidebar-width'
export const SIDEBAR_WIDTH_DEFAULT_PX = 256
export const SIDEBAR_WIDTH_MIN_PX = 180
// Cookie sanity ceiling only - the server can't know the viewport, so the real
// maximum is computed client-side from window width. See getMaxSidebarWidth.
export const SIDEBAR_WIDTH_ABSOLUTE_MAX_PX = 2000
// Page content never gets narrower than this, however wide the window is.
export const SIDEBAR_CONTENT_FLOOR_PX = 480

const SIDEBAR_PREFERENCE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export function parseSidebarCollapsedPreference(value: string | undefined): boolean {
  if (value === 'false') return false
  if (value === 'true') return true

  return true
}

export function serializeSidebarCollapsedPreference(collapsed: boolean, secure: boolean): string {
  const secureAttribute = secure ? '; Secure' : ''

  return `${SIDEBAR_COLLAPSED_COOKIE_NAME}=${String(collapsed)}; Path=/; Max-Age=${SIDEBAR_PREFERENCE_MAX_AGE_SECONDS}; SameSite=Lax${secureAttribute}`
}

export function parseSidebarWidthPreference(value: string | undefined): number {
  if (value === undefined || value === '') return SIDEBAR_WIDTH_DEFAULT_PX
  if (!/^-?\d+$/.test(value)) return SIDEBAR_WIDTH_DEFAULT_PX

  const parsed = Number(value)
  if (
    !Number.isInteger(parsed) ||
    parsed < SIDEBAR_WIDTH_MIN_PX ||
    parsed > SIDEBAR_WIDTH_ABSOLUTE_MAX_PX
  ) {
    return SIDEBAR_WIDTH_DEFAULT_PX
  }

  return parsed
}

export function serializeSidebarWidthPreference(widthPx: number, secure: boolean): string {
  const clampedWidthPx = Math.min(
    SIDEBAR_WIDTH_ABSOLUTE_MAX_PX,
    Math.max(SIDEBAR_WIDTH_MIN_PX, widthPx)
  )
  const secureAttribute = secure ? '; Secure' : ''

  return `${SIDEBAR_WIDTH_COOKIE_NAME}=${String(clampedWidthPx)}; Path=/; Max-Age=${SIDEBAR_PREFERENCE_MAX_AGE_SECONDS}; SameSite=Lax${secureAttribute}`
}

/** Migrates the preference written by PR #892 before any sidebar markup can paint. */
export function getSidebarPreferenceMigrationScript(): string {
  const cookieName = JSON.stringify(SIDEBAR_COLLAPSED_COOKIE_NAME)
  const maxAge = JSON.stringify(SIDEBAR_PREFERENCE_MAX_AGE_SECONDS)

  return `(function(){try{var name=${cookieName};var hasCookie=document.cookie.split('; ').some(function(row){return row.indexOf(name+'=')===0});if(hasCookie){localStorage.removeItem(name);return}var stored=localStorage.getItem(name);if(stored!=='true'&&stored!=='false')return;var secure=location.protocol==='https:'?'; Secure':'';document.cookie=name+'='+stored+'; Path=/; Max-Age='+${maxAge}+'; SameSite=Lax'+secure;var migrated=document.cookie.split('; ').some(function(row){return row.indexOf(name+'=')===0});if(migrated){localStorage.removeItem(name);document.documentElement.style.visibility='hidden';setTimeout(function(){document.documentElement.style.visibility=''},5000);location.reload()}}catch{}})()`
}
